import algoliasearch, { SearchClient } from 'algoliasearch/lite';

const appId = import.meta.env.VITE_APP_ALGOLIA_APP_ID;
const apiKey = import.meta.env.VITE_APP_ALGOLIA_SEARCH_API_KEY;
if (!appId || !apiKey) {
  throw Error('Algolia creds not present');
}
export const searchClient: SearchClient = algoliasearch(appId, apiKey);
